import KeywordFilter from "components/filters/Filters/KeywordFilter";
import React from "react";
import AddressFilter from "components/filters/Filters/AddressFilter";
import VenueCategoryFilter from "components/filters/Filters/VenueCategoryFilter";
import TagFilter from "components/filters/Filters/TagFilter";
import VenueCapacityFilter from "components/filters/Filters/VenueCapacityFilter";

interface FiltersProps {
  initialTags: server.dto.TagSmall[]
}

const Filters = (props: FiltersProps) => {
  return <>
    <KeywordFilter
      placeholder={RESX.GeneralLabels.Keyword}
    />
    <AddressFilter />
    <VenueCategoryFilter />
    <VenueCapacityFilter maxCapacity={serverReference.constants.venue.maxCapacity} />
    <TagFilter
      mainArea="company"
      initialTags={props.initialTags}
    />
  </>;
};

export default Filters;